export const SET_PARAMETER_SITES_UNIT_OPERATIONS_FILTERS = "SET_PARAMETER_SITES_UNIT_OPERATIONS_FILTERS";
